// @flow

import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import _ from 'lodash';
import Loading from 'client/components/Loading';
import Navbar from 'client/components/Navbar';
import HorizontalList from 'client/components/HorizontalList';
import { getLists, getCategories, clearLists } from 'client/containers/Home/redux';
import Pagination from './components/Pagination';
import Styles from './styles';

type Props = {
  checkRenderedDom : () => void,
  verticalMove : (direction : string) => void,
  match : any,
  getLists : (data : any) => void,
  getCategories : () => void,
  clearLists : () => void,
  getListsLoading : boolean,
  listsData : Map,
  nextPageLink : string,
  getCategoriesLoading : boolean,
  categoriesData : Map,
};

const Lists = ({
  clearLists,
  getLists,
  getCategories,
  getListsLoading,
  listsData,
  nextPageLink,
  getCategoriesLoading,
  categoriesData,
  checkRenderedDom,
  match,
  verticalMove,
} : Props) => {
  const [currentPage, setCurrentPage] = useState(0);
  let currentTagID = null;

  useEffect(() => {
    if (!_.get(match, ['params', 'cat_id'])) {
      setCurrentPage(1);
      setTimeout(() => {
        getLists({
          id: null,
        });
      }, 100);
    } else if (_.get(match, ['params', 'cat_id']) !== currentTagID) {
      setCurrentPage(1);
      getLists({
        cat_id: _.get(match, ['params', 'cat_id']),
      });
    }
    currentTagID = _.get(match, ['params', 'cat_id']);
  }, [_.get(match, ['params', 'cat_id'])]);

  useEffect(() => {
    getCategories();
    window.durationStorage = JSON.parse(localStorage.getItem('aparatTvPlayer')) || {};
    return () => {
      clearLists();
    };
  }, []);

  const handleChangePage = (type : string) => {
    if ((type === 'next') && nextPageLink) {
      const nextCurrentPage = currentPage + 1;
      setCurrentPage(nextCurrentPage);
      getLists({
        cat_id: _.get(match, ['params', 'cat_id']),
        nextPageLink,
      });
    }
    checkRenderedDom();
  };

  const handleBackToHome = () => {
    setCurrentPage(1);
    if (getLists) {
      getLists();
    }
    checkRenderedDom();
  };

  return (
    <Styles>
      <Navbar verticalMove={verticalMove} />
      <div>
        {
          (getListsLoading || getCategoriesLoading) ? <Loading /> : (
            <div className="content">
              <div className="listsContainer">
                {categoriesData && categoriesData.size > 0 && !_.get(match, ['params', 'cat_id']) && currentPage === 1 && (
                  <HorizontalList
                    size={18}
                    listData={categoriesData}
                    info={{
                      listType: 'taglist',
                    }}
                  />
                )}
                {
                  (listsData && listsData.size > 0 && listsData.get('list_data') && listsData.get('list_data').size > 0) && (
                    <Fragment>
                      {
                        listsData.get('list_data')
                        .map((item : any) : any => (item && item.size > 0) && (
                          <HorizontalList
                            key={item.get('id')}
                            listData={item}
                          />
                        ))
                      }
                      {
                        (currentPage > 0 && !_.get(match, ['params', 'cat_id'])) && (
                          <Pagination
                            listsCount={listsData.getIn(['list_info', 'row_count'])}
                            currentPage={currentPage}
                            onChangePage={handleChangePage}
                            nextPageLink={nextPageLink}
                            onBackToHome={handleBackToHome}
                          />
                        )
                      }
                    </Fragment>
                  )
                }
              </div>
            </div>
          )
        }
      </div>
    </Styles>
  );
};

export default connect(
  (state : any) => ({
    getListsLoading: state.getIn(['Home', 'getListsLoading']),
    listsData: state.getIn(['Home', 'listsData']),
    nextPageLink: state.getIn(['Home', 'nextPageLink']),

    getCategoriesLoading: state.getIn(['Home', 'getCategoriesLoading']),
    categoriesData: state.getIn(['Home', 'categoriesData']),
  }),
  {
    getLists,
    getCategories,
    clearLists,
  },
)(Lists);
